export class GerenciarAtividade {
    id: number;
    id_natureza: number;
    observacao: string
    titulo: string;
    cpf: string;
    data_fim: Date;
    codigo: string;
    id_situacao: number;
    id_lotacao: number;
    anexo_gerenciar_atividade: any[];

    /**
     *Utiliza do construtor para carregar os objetos da classe
     */
    constructor(cadastro: any, listaAnexo: any[]) {
        this.id = cadastro.id;
        this.id_natureza = cadastro.id_natureza;
        this.observacao = cadastro.observacao;
        this.titulo = cadastro.titulo;
        this.cpf = cadastro.cpf;
        this.data_fim = cadastro.data_fim;
        this.codigo = cadastro.codigo;
        this.id_situacao = cadastro.id_situacao;
        this.anexo_gerenciar_atividade = listaAnexo;
        this.id_lotacao = parseInt(localStorage.getItem('lotacao'));
    }
}


// WEBPACK FOOTER //
// ./src/app/entity/gerenciamento-atividade.model.ts